import React, { useState, useEffect } from "react";
import Header from "../../layout/Header";
import { getDate } from "../../../../utils/helper";
import { getDynamicdata, transactionRegistration, updateDynamicData } from "../../../../components/pages/campaigns/services";
import { decrypt } from "../../../../utils/encodingdecoding";
import { getAllCustomer } from "../../../../actions/auth";
import Paginated from "./Paginated";
import { FINODAYA_COLUMNS } from "./column"

const FinodayaApproval = () => {
    const [loader, setLoader] = useState(false);
    const [data, setData] = useState([]);
    const id = decrypt(localStorage.getItem("Id"))

    useEffect(() => {
        const fetch = async () => {
            setLoader(true);

            let tempToken = JSON.parse(localStorage.getItem("token_gen"));
            tempToken = tempToken?.access_token;

            const res = await getDynamicdata(
                tempToken,
                "merchantCode",
                "MER000503",
                1,
                50
            );

            if (res?.message === "Success") {
                if (Array.isArray(res?.data) && res?.data?.length > 0) {

                    const formattedData = res.data
                        ?.filter((item) => item?.requestData?.name)
                        ?.map((item) => {
                            const status =
                                item?.requestData?.status || "Pending";

                            return {
                                ...item,

                                name: item?.requestData?.name || "",
                                email: item?.requestData?.email || "",
                                mobile: item?.requestData?.mobile || "",
                                description: item?.requestData?.description || "",
                                createdAt: item?.requestData?.createdAt || "",

                                action: (
                                    <div className="d-flex gap-2 align-items-center justify-content-center">

                                        {/* {!item?.requestData?.status && (
                                            <button className="btn btn-warning btn-sm">
                                                Pending
                                            </button>
                                        )} */}

                                        {status === "Approved" && (
                                            <button className="btn btn-success btn-sm">
                                                Approved
                                            </button>
                                        )}

                                        {status === "Rejected" && (
                                            <button className="btn btn-danger btn-sm">
                                                Rejected
                                            </button>
                                        )}

                                        {!item?.requestData?.status && (
                                            <>
                                                <button
                                                    className="btn btn-success btn-sm"
                                                    onClick={() =>
                                                        handleOrderAction(item, "Approved")
                                                    }
                                                >
                                                    Approve
                                                </button>

                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() =>
                                                        handleOrderAction(item, "Rejected")
                                                    }
                                                >
                                                    Reject
                                                </button>
                                            </>
                                        )}
                                    </div>
                                ),
                            };
                        });

                    setData(formattedData?.reverse());

                } else {
                    setData([]);
                }
            }

            setLoader(false);
        };

        fetch();
    }, []);
    const handleOrderAction = async (ele, status) => {
        const temp = {
            ...ele,
            requestData: {
                ...ele.requestData,
                status: status,
            },
        };
        setLoader(true);
        let tempToken = JSON.parse(localStorage.getItem("token_gen"));
        const res = await updateDynamicData(tempToken?.access_token, temp)
        if (res.message === "Success") {
            if (status === "Approved") {
                const transBody = {
                    "activityType": "leads",
                    "email": decrypt(localStorage.getItem("email")),
                    "schemacode": "TSC000341"
                }
                await transactionRegistration(
                    tempToken?.access_token,
                    JSON.stringify(transBody)
                );
            }

            setData((prevData) =>
                prevData.map((item) => {
                    if (item.id === ele.id) {
                        return {
                            ...item,
                            requestData: {
                                ...item.requestData,
                                status: status,
                            },

                            action: (
                                <div className="d-flex gap-2 align-items-center">

                                    {status === "Approved" && (
                                        <button className="btn btn-success btn-sm">
                                            Approved
                                        </button>
                                    )}

                                    {status === "Rejected" && (
                                        <button className="btn btn-danger btn-sm">
                                            Rejected
                                        </button>
                                    )}
                                </div>
                            ),
                        };
                    }

                    return item;
                })
            );
        }
        setLoader(false);
    };

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <Header name={"Client Leads"} />
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__customersCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>Client Leads Detail</h4>
                            </div>
                            {/* <div className="dashboard__right">
                                <button onClick={() => generateCSV()} className="btn btn-default">
                                    <i
                                        class="fa-solid fa-download"
                                        style={{ marginRight: "10px" }}
                                    ></i>
                                    Download Orders
                                </button>
                            </div> */}
                        </div>
                        <div className="dashboard__body">
                            <Paginated
                                data={data}
                                columns={FINODAYA_COLUMNS}
                                setLoader={setLoader}
                                loader={loader}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};



export default FinodayaApproval